import React, { Component } from 'react';
import _get from 'lodash.get';
import { Image } from '../../../../../ui-kit';
import FileTypeIcon from '../../FileTypeIcon';
import InteractiveOverlay from '../../InteractiveOverlay';
import getVideoThumbnail from '../utils/getVideoThumbnail';
import ImagePreview from '../../ImagePreview/components/ImagePreview';
import { VIDEO } from '../../../../../common/constants/fileTypes';
import '../styles/_video-preview.scss';
import {
  attemptToPlayVideo,
  hasTranscodedVideoFiles } from
'../../../../../common/utils';
import getDarkModeImageProps from '../../../utils/getDarkModeImageProps';
import PlayerComponent from '../../../../Player/components/Player';

const TRANSCODE_FAILED = 'TRANSCODE_FAILED';


















function getVideoId({ assetId }) {
  return `video-preview-${assetId}`;
}

function handleRightClick(e) {
  e.preventDefault();
  e.stopPropagation();
}

/**
 * Use the lower definition file, falling back to the original.
 *
 * @param {Asset} asset
 *
 * @return {Object}
 */
function getSourceFile(asset) {
  const { assetFiles } = asset || {};

  if (!assetFiles) {return {};}

  return assetFiles.SD || assetFiles.ORIGINAL || {};
}

function getThumbnail(asset) {
  const { assetFiles } = asset || {};

  return assetFiles && assetFiles.THUMBNAIL;
}

export default class VideoPreview extends Component {




  constructor() {
    super();

    this.state = {
      playing: false,
      buffering: false,
      startTime: 0
    };
  }

  componentDidMount() {
    const { asset, subscribeToAssetTranscoded } = this.props;

    if (hasTranscodedVideoFiles(asset)) {return;}

    subscribeToAssetTranscoded(asset.assetId);
  }

  componentWillUnmount = () => {
    if (this._videoRef) {
      this._videoRef.removeEventListener('contextmenu', handleRightClick);
      this._videoRef = null;
    }
  };

  onVideoReady = () => {
    this.setState({ buffering: false });
  };

  setVideoRef = (videoRef) => {
    const { autoPlay } = this.props;
    if (!videoRef) {return;}

    this._videoRef = videoRef;
    if (autoPlay) {
      this.enableAutoplay();
    }

    videoRef.addEventListener('contextmenu', handleRightClick);
    videoRef.addEventListener('loadeddata', this.onVideoReady);
  };

  toggleVideoPlay = () => {
    const { asset } = this.props;
    const { playing, startTime } = this.state;

    if (playing && this._videoRef) {this._videoRef.pause();}

    const thumbnail = playing ? getVideoThumbnail(`#${getVideoId(asset)}`) : void 0;
    const newStartTime = this._videoRef && playing ? this._videoRef.currentTime : startTime;

    this.setState(
      ({ playing: currentPlaying }) => ({
        playing: !currentPlaying,
        overrideThumbnail: thumbnail,
        startTime: newStartTime,
        buffering: !currentPlaying
      }),
      this.toggleVideoPlaySetStateCallback
    );
  };

  toggleVideoPlaySetStateCallback = () => {
    const videoRef = this._videoRef;
    const { playing: latestPlaying } = this.state;

    if (!videoRef || !latestPlaying) {return;}

    attemptToPlayVideo(videoRef);
  };

  restartPreview = () => {
    if (!this._videoRef) {return;}

    this._videoRef.currentTime = 0;

    this.setState({ playing: false, overrideThumbnail: void 0, startTime: 0 });
  };

  getCurrentTime = () => {
    if (!this._videoRef) {return 0;}

    return this._videoRef.currentTime;
  };

  enableAutoplay() {
    if (!this._videoRef) {return;}
    this._videoRef.muted = true;
    this._videoRef.play();
  }

  render() {
    const {
      asset,
      hideFileTypeIcon,
      darkMode,
      canPlayVideo,
      isEditAssetDetailsModal,
      autoPlay
    } = this.props;
    const { playing, buffering, startTime, overrideThumbnail } = this.state;
    const { sourceUrl } = getSourceFile(asset);
    const isTranscoding = !_get(asset, 'assetFiles.SD');
    const transcodeFailed = _get(asset, 'assetFiles.ORIGINAL', {}).status === TRANSCODE_FAILED;
    const originalThumbnail = getThumbnail(asset);
    const colourMap = getDarkModeImageProps({ darkMode });
    if (isTranscoding || transcodeFailed) {
      return (
        <ImagePreview
          hideFileTypeIcon
          type={VIDEO}
          imageProps={{
            defaultImageIcon: transcodeFailed ? 'unsupported' : 'rushedit',
            defaultIconBackground: colourMap.background,
            defaultIconColour: colourMap.icon,
            defaultIconSize: 40,
            defaultIconSubtitle: transcodeFailed ? 'Type Not Supported' : 'Preparing',
            defaultIconAnimated: !transcodeFailed
          }} />);


    }

    if (!canPlayVideo) {
      return (
        <ImagePreview
          asset={asset}
          type={VIDEO}
          hideFileTypeIcon={hideFileTypeIcon}
          darkMode={darkMode} />);


    }

    if (isEditAssetDetailsModal) {
      return (
        <div className="video-preview video-preview--edit-asset-modal">
          <div className="video-preview__video video-preview__video--edit-asset-modal">
            <PlayerComponent
              asset={asset}
              assetId={asset.assetId}
              controlsVisible
              minWidth={330}
              minHeight={330}
              standardVideo
              controlsOutside
              showComments={false} />

          </div>
        </div>);

    }

    if (autoPlay) {
      return (
        // eslint-disable-next-line jsx-a11y/media-has-caption
        <video
          crossOrigin="anonymous"
          id={getVideoId(asset)}
          ref={this.setVideoRef}
          controls="controls"
          className="video-preview__video"
          src={sourceUrl && `${sourceUrl}${startTime ? `#t=${startTime}` : ''}`} />);


    }


    return (
      <InteractiveOverlay
        onPlay={this.toggleVideoPlay}
        onPause={this.toggleVideoPlay}
        onRestart={this.restartPreview}
        playing={playing}
        getCurrentTime={this.getCurrentTime}
        loading={buffering}>

        {({ overlay, hovering, onMouseOver, onMouseLeave }) =>
        <div
          className="video-preview"
          onMouseOver={onMouseOver}
          onMouseLeave={onMouseLeave}
          onDragStart={onMouseLeave}
          onFocus={onMouseOver}
          onBlur={onMouseLeave}
          role="button"
          tabIndex={0}>

            {overlay}
            {!hideFileTypeIcon && (!playing || hovering) ? <FileTypeIcon name="projects" /> : null}
            {
          playing ? (

          /* eslint-disable-next-line jsx-a11y/media-has-caption */
          <video
            crossOrigin="anonymous"
            id={getVideoId(asset)}
            autoPlay
            ref={this.setVideoRef}
            className="video-preview__video"
            src={sourceUrl && `${sourceUrl}${startTime ? `#t=${startTime}` : ''}`} />) :



          <Image
            defaultImageIcon="projects"
            imageUrl={
            overrideThumbnail || originalThumbnail && originalThumbnail.sourceUrl}

            height="100%"
            width="100%"
            default />}



          </div>}

      </InteractiveOverlay>);

  }
}